angular.module('zc.zenclerkS')
  .component('zcsInvoice', {
    templateUrl: '/templates/zenclerk_s/sites/invoices/show/zcs_invoice.html',
    controllerAs: 'vm',
    bindings: {
      invoice: '=',
      currency: '='
    },
    controller() {

    },
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/show/zcs_invoice.directive.js